var quickAddSelectors = document.querySelectorAll(".quick-add__custom-selector");
quickAddSelectors.forEach((selector) => {
    selector.addEventListener("change", () => {
        const variantId = selector.value;
        const selectedOption = selector.options[selector.selectedIndex];
        const currentForm = selector.closest(".shopify-product-form");
        const input = currentForm.querySelector('input[name="id"]');
        const atc = currentForm.querySelector('button[type="submit"]');

        const optionPrice = selectedOption.getAttribute("data-quickadd-select-price");
        const optionComparePrice = selectedOption.getAttribute("data-quickadd-select-compare");

        input.value = variantId;
        atc.querySelector("[data-quickadd-price]").innerHTML = optionPrice;

        if (optionComparePrice == optionPrice) {
            atc.querySelector("[data-quickadd-compare-at-price]").innerHTML = "";
        } else {
            atc.querySelector("[data-quickadd-compare-at-price]").innerHTML = optionComparePrice;
        }

    });
});







// document.addEventListener('DOMContentLoaded', function () {
//     setTimeout(() => {
//         initializeCustomQuickAdd();
//     }, 1000);
// });

// function initializeCustomQuickAdd() {
//     var customQuickaddContainers = document.querySelectorAll(".product-card__quick-add");
//     customQuickaddContainers.forEach((quickAddContainer) => {
//         const inputs = quickAddContainer.querySelectorAll(".kaching-bundles__bars input");
        
//         // Create the <select> element
//         const select = document.createElement("select");
//         select.className = "quick-add__custom-selector";
    
//         // Populate the <select> with <option>s based on the inputs
//         inputs.forEach((input, index) => {
//             const option = document.createElement("option");
//             option.value = input.value || `option${index + 1}`;
//             option.textContent = input.getAttribute("data-label") || `Option ${index + 1}`;
//             if (index === 0) {
//                 option.selected = true; // Select the first option by default
//             }
//             select.appendChild(option);
//         });

//         // Insert the <select> at the top of the .product-card__quick-add container
//         quickAddContainer.insertBefore(select, quickAddContainer.firstChild);
//     });

//     var customQuickaddSelector = document.querySelectorAll(".quick-add__custom-selector");
//     customQuickaddSelector.forEach((quickAdd) => {
//         quickAdd.addEventListener('change', function () {
//             const selectedIndex = this.selectedIndex; // Get the selected index
//             const container = quickAdd.closest(".product-card__quick-add");
//             const bars = container.querySelectorAll('.kaching-bundles__bar');

//             bars.forEach((bar, index) => {
//                 const input = bar.querySelector('input[type="radio"]');

//                 if (index === selectedIndex) {
//                     input.checked = true;
//                     bar.classList.add('kaching-bundles__bar--selected');
//                     input.focus();
//                     input.dispatchEvent(new Event('change', { bubbles: true }));
//                 } else {
//                     input.checked = false;
//                     bar.classList.remove('kaching-bundles__bar--selected');
//                 }
//             });
//         });
//     });
// }